module.exports = __webpack_public_path__ + "img/pw.857004b9.svg";